import { Component, OnInit } from '@angular/core';
import { getPowerInformationTagDefinitions } from '~app/linking/tag-definitions/T14';
import { NeveMeasurementsService } from '../measurements/neve-measurements.service';
@Component({
  selector: 'qm-neve-base',
  templateUrl: './neve-base.component.html'
})
export class NeveBaseComponent implements OnInit {
  constructor(
    // private valmetDna: ValmetDnaService,
    private readonly measurements: NeveMeasurementsService
    ) {
  }

  ngOnInit() {
    // WIP, will be fixed in MR-845
    this.measurements.init(getPowerInformationTagDefinitions());
  }
}
